import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { isExternalVideo } from '@wix/wix-vod-shared/src/common/ui-selectors/video/video-origin';
import getVideoUrls from 'widget/selectors/get-video-urls';
import ResizedImage from 'shared/components/resized-image/resized-image';
import { openBuyVideoOverlay } from 'widget/redux/client/actions/mobile-overlay-openners/payment-pages-actions';
import { openVideoPage } from 'widget/redux/client/actions/mobile-overlay-openners/main-openners';
import { getPlayerCoverUrl } from './player-cover-selector';
import ThreeRowsWidgetOverlay from 'widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget';

import styles from './cover-with-overlay.styl';


@connect(
  (state, props) => ({
    channelData: getChannelForWidget(state),
    currentSiteUser: getCurrentSiteUser(state),
    videoUrls: getVideoUrls(state, props),
    coverUrl: getPlayerCoverUrl(state, props),
  }),
  (dispatch, { videoItem }) => ({
    onBuyVideoClick: () => dispatch(openBuyVideoOverlay(videoItem.id)),
    onOpenVideoClick: () => dispatch(openVideoPage(videoItem.id)),
  })
)
export default class CoverWithOverlay extends React.Component {

  static propTypes = {
    channelData: PropTypes.object,
    canShowChannelCover: PropTypes.bool,
    onBuyVideoClick: PropTypes.func,
    onOpenVideoClick: PropTypes.func,
    onSignInRequested: PropTypes.func,

    videoItem: PropTypes.object,
    showChannelCover: PropTypes.bool,
    className: PropTypes.string,
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number,
    currentSiteUser: PropTypes.object,
    onPlayClick: PropTypes.func,
    onMemberSignUp: PropTypes.func,
    videoUrls: PropTypes.object,
    coverUrl: PropTypes.string,
  };

  @autobind
  onPlayClick() {
    const {
      onPlayClick,
      channelData,
      videoItem,
      currentSiteUser,
      onMemberSignUp,
      videoUrls,
    } = this.props;

    const accessActionName = getFullAccessActionName(channelData, videoItem, currentSiteUser);

    if (accessActionName === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
      onMemberSignUp();
      return;
    }

    if (!videoUrls && !isExternalVideo(videoItem)) {
      return;
    }

    onPlayClick();
  }

  render() {
    const {
      videoItem,
      showChannelCover,
      onOpenVideoClick,
      onBuyVideoClick,
      onSignInRequested,
      itemWidth,
      itemHeight,
      className,
      coverUrl,
    } = this.props;

    return (
      <ResizedImage className={className}
                    src={coverUrl}
                    width={itemWidth}
                    height={itemHeight} >
        <ThreeRowsWidgetOverlay videoItem={videoItem}
                                className={styles['slidable-overlay']}
                                showChannelCover={showChannelCover}
                                onSignInRequested={onSignInRequested}
                                onOpenVideoClick={onOpenVideoClick}
                                onBuyVideoClick={onBuyVideoClick}
                                onPlayClick={this.onPlayClick} />

      </ResizedImage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mobile/views/home/components/cover-with-overlay/cover-with-overlay.js